/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CampaignStatusApiModel } from '../../models/campaign-status-api-model';

export interface RetrieveCampaignStatus$Params {
  id: string;
}

export function retrieveCampaignStatus(http: HttpClient, rootUrl: string, params: RetrieveCampaignStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<CampaignStatusApiModel>> {
  const rb = new RequestBuilder(rootUrl, retrieveCampaignStatus.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CampaignStatusApiModel>;
    })
  );
}

retrieveCampaignStatus.PATH = '/campaigns/{id}';
